// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"627":"a984f8e5","658":"ebee701f","727":"58a0cf40","836":"23c385ec","924":"e45adaa5","964":"03bcc44f","973":"610ef970"}[chunkId] + ".css";
};